import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as AdminComponent } from "~/containers/specifics/admin/Page";
import { Page as Component } from "~/containers/specifics/home/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export const PATH = "/";

const Home: NextPage = () => {
	const { data: account } = useItandiAccount().currentAccount();
	if (account === null) {
		return null;
	}
	if (account.isAdmin && account.company === null) {
		return (
			<>
				<NskHead title="管理者ページ" />
				<AdminComponent />
			</>
		);
	}
	return (
		<>
			<NskHead title="HOME" />
			<Component />
		</>
	);
};

export default Home;
